import { defineAction } from '~/prix'
import residenceGeoMockAction from './residenceGeoMock.action.json' with { type: 'json' }
import { z } from 'zod'

const residenceGeoMockDefinition = defineAction({
  ...residenceGeoMockAction,

  input: z.object({
    seed: z.number().default(10),
  }),
  output: z.object({}),
})

export default residenceGeoMockDefinition
